import React, { createContext, useContext, useState, useEffect } from 'react';
import environment from '../config/environment';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [organization, setOrganization] = useState(null);
  const [loading, setLoading] = useState(true);
  const { apiUrl } = environment();

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const storedOrg = localStorage.getItem('organization');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    if (storedOrg) {
      setOrganization(JSON.parse(storedOrg));
    }
    setLoading(false);
  }, []);

  const getToken = async () => {
    return localStorage.getItem('authToken');
  };

  const login = async (credentials) => {
    try {
      const response = await fetch('http://localhost:5000/api/admin/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(credentials)
      });

      if (!response.ok) {
        throw new Error('Login failed');
      }

      const data = await response.json();
      
      if (data.token) {
        localStorage.setItem('authToken', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        
        // Fetch organization data if user is admin
        if (data.user.role === 'admin') {
          const orgResponse = await fetch(`http://localhost:5000/api/organizations/byAdmin/${data.user._id}`, {
            headers: {
              'Authorization': `Bearer ${data.token}`
            }
          });
          
          if (orgResponse.ok) {
            const orgData = await orgResponse.json();
            setOrganization(orgData);
            localStorage.setItem('organization', JSON.stringify(orgData));
          }
        }
        
        setUser(data.user);
        return { success: true, role: data.user.role };
      }
      
      throw new Error('Login failed');
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  };

  const logout = () => {
    setUser(null);
    setOrganization(null);
    localStorage.removeItem('user');
    localStorage.removeItem('organization');
    localStorage.removeItem('authToken');
  };

  const value = {
    user,
    organization,
    loading,
    isAuthenticated: !!user,
    isAdmin: user?.role === 'admin',
    login,
    logout,
    getToken
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}; 